import {ExamResultTypeEnum, IExamResult} from 'domain/usecases';

import {useQueryParams} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {textHandle} from 'presentation/utils/textHandle';
import {useCallback, useMemo} from 'react';
import {ExamCardItemType} from '../components/ExamCard/types';
import {useOpenExamDrawerStore} from '../store/useOpenExamDrawerStore';
import {usePatientData} from '../../PatientData/hooks/usePatientData';
import {useGetExamResultsQuery} from 'presentation/modules/examResults/queries/useGetExamResultsQuery';
const {exam: examDictionary, filter} = translations['pt-br'].privateFlow.myHospitalization.exams;

export const useResultsReleased = () => {
	const {
		SEARCH_PARAMS: {category},
		clearSearch,
	} = useQueryParams();
	const setOpenDrawer = useOpenExamDrawerStore(state => state.setDataExam);
	const {data: patient} = usePatientData();
	const {data, isError, isLoading, refetch} = useGetExamResultsQuery({
		cdAtendimento: patient?.serviceCode,
	});
	const isEmpty = !data || data.length === 0;

	const handleFormatterItem = useCallback(
		(exam: IExamResult): ExamCardItemType => {
			let examName = examDictionary;
			if (exam.dsTipoExame === ExamResultTypeEnum.IMAGE) {
				examName += ` de ${filter.image.toLowerCase()}`;
			} else {
				examName += ` ${filter.laboratory.toLowerCase()}`;
			}

			const laudos = exam.laudos ? exam.laudos.filter(laudo => laudo.dtLaudo) : [];
			const {date, time} =
				laudos && laudos.length > 0 && laudos[0].dtLaudo
					? {
							date: laudos[0].dtLaudo?.split(' ')[0] ?? '',
							time: laudos[0].dtLaudo?.split(' ')[1]?.substring(0, 5) ?? '',
						}
					: {date: '', time: ''};

			return {
				examDate: date,
				examTime: time,
				examType: textHandle(exam?.dsTipoExame ?? '').removeSpecialChar(),
				hospitalName: textHandle(
					patient?.legalProviderName?.toLocaleLowerCase() ?? '',
				).capitalize(),
				doctorName: textHandle(exam?.nmSolicitante ?? '').capitalize(),
				examName,
				handleOpenDetails: () => setOpenDrawer({title: examName, list: exam.laudos}),
			};
		},
		[patient],
	);
	const formattedData = useMemo(() => data?.map(handleFormatterItem) ?? [], [data]);

	const filteredData = useMemo(
		() =>
			formattedData.filter(exam =>
				category ? category.toLowerCase() === exam.examType.toLowerCase() : true,
			),
		[formattedData, category],
	);

	const isEmptyFiltered = filteredData?.length === 0;

	return {
		data: filteredData,
		isEmpty,
		filteredData,
		clearSearch,
		isEmptyFiltered,
		isError,
		isLoading,
		refetch,
	};
};
